import "./index.css";
import useOffcanvasStore from "store/offcanvasStore";

const ExpandableButton = (props) => {
  const { title, icon, formId, offcanvasProps = {} } = props;
  const { openOffcanvas } = useOffcanvasStore();

  return (
    <div className="justify-content-end d-flex position-relative">
      <button
        className=" btn btn-app expand-btn"
        type="button"
        onClick={() => openOffcanvas(formId, offcanvasProps)}>
        <i className={`fs-2 ms-3 ${icon}`}></i>
        <span className="fs-3 ms-3 text-nowrap fw-bold button-text">
          &nbsp;{title}
        </span>
      </button>
    </div>
  )
}

export default ExpandableButton;